export function customTestimonials() {
    let $window = $(window);
    let $header = $(".header");
    let $testimonialsHolder = $(".custom-testimonials");
    let $testimonialsNavItem = $(".custom-testimonials-nav .item");
    let $testimonialsListItem = $(".custom-testimonials-box");
    let headerHeight = $header.innerHeight();
    const stickyArea = $testimonialsHolder;
    const stickyNavItem = $testimonialsNavItem;
    const sections = $testimonialsListItem;
    let scrollTop;


    function sticky() {
        if (window.innerWidth >= 1024) {
            scrollTop = $(window).scrollTop();
            let stickyAreaHeight = stickyArea.innerHeight();
            let stickyAreaTop = stickyArea.offset().top;
            let stickyAreaBottom = stickyAreaHeight + stickyAreaTop - headerHeight;

            if (scrollTop > stickyAreaTop - headerHeight && scrollTop < stickyAreaBottom - headerHeight) {
                stickyArea.addClass('has-fixed-child');
            } else if (scrollTop > stickyAreaBottom - headerHeight) {
                stickyArea.removeClass('has-fixed-child');
            } else {
                sections.removeClass('active');
                stickyNavItem.removeClass('active');
                stickyArea.removeClass('has-fixed-child');
            }

            if (stickyArea.hasClass('has-fixed-child')) {
                sections.each(function (index, section) {
                    let $this = $(section);
                    let itemOffsetTop = $this.offset().top;
                    if (scrollTop >= itemOffsetTop - ((($window.innerHeight() / 2) - $this.innerHeight() / 2) + headerHeight / 2)) {
                        let sectionIndex = $this.index();
                        if (!$this.hasClass("active")) {
                            $this.addClass('active').prev().addClass("prev");
                            if (stickyNavItem.eq(sectionIndex).length) {
                                stickyNavItem.eq(sectionIndex).addClass("active").prev().addClass("prev");
                            }
                        }
                    } else {
                        $this.removeClass('active').prev().removeClass("prev");
                        let sectionIndex = $this.index();
                        if (stickyNavItem.eq(sectionIndex).length) {
                            stickyNavItem.eq(sectionIndex).removeClass("active").prev().removeClass("prev");
                        }
                    }
                });
            }
        } else {
            stickyArea.removeClass('has-fixed-child');
        }
    }

    $testimonialsNavItem.on("click", function () {
        let $this = $(this);
        let index = $this.index();
        if ($window.innerWidth() >= 1024) {
            $("html, body").animate({scrollTop: $testimonialsListItem.eq(index).offset().top - ((($window.innerHeight() / 2) - $testimonialsListItem.eq(index).innerHeight() / 2) + headerHeight / 2) + 5}, 500);
        } else {
            $testimonialsNavItem.removeClass("active");
            $testimonialsListItem.removeClass("active");
            $testimonialsListItem.eq(index).addClass("active");
            $this.addClass("active");
        }
    });
    $(window).on("load scroll resize", function () {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customTestimonials.js